var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	3155: {
		fallback: function() { return __webpack_require__.e(6540).then(function() { return function() { return __webpack_require__(96540); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	77938: {
		fallback: function() { return __webpack_require__.e(2165).then(function() { return function() { return __webpack_require__(32165); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.9.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@qikserve/utils/cdn",

	},
	62508: {
		fallback: function() { return __webpack_require__.e(7435).then(function() { return function() { return __webpack_require__(77435); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.9.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@qikserve/utils/currency",

	},
	59955: {
		fallback: function() { return __webpack_require__.e(2635).then(function() { return function() { return __webpack_require__(72635); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "25.3.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "i18next",

	},
	80103: {
		fallback: function() { return __webpack_require__.e(8096).then(function() { return function() { return __webpack_require__(40961); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	77037: {
		fallback: function() { return __webpack_require__.e(8096).then(function() { return function() { return __webpack_require__(49785); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "7.43.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-hook-form",

	},
	34477: {
		fallback: function() { return __webpack_require__.e(8096).then(function() { return function() { return __webpack_require__(32389); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "15.6.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-i18next",

	},
	38826: {
		fallback: function() { return __webpack_require__.e(3860).then(function() { return function() { return __webpack_require__(63860); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.9.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@qikserve/utils/emitter",

	},
	11330: {
		fallback: function() { return __webpack_require__.e(8096).then(function() { return function() { return __webpack_require__(62439); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@qikserve/online-ordering-cookie-consent/react",

	},
	7566: {
		fallback: function() { return __webpack_require__.e(9171).then(function() { return function() { return __webpack_require__(89171); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@qikserve/online-ordering-cookie-consent",

	},
	53279: {
		fallback: function() { return __webpack_require__.e(8096).then(function() { return function() { return __webpack_require__(57555); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.3.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@qikserve/store/cross-sell",

	},
	94291: {
		fallback: function() { return __webpack_require__.e(3803).then(function() { return function() { return __webpack_require__(93803); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.3.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@qikserve/store/menu",

	},
	60398: {
		fallback: function() { return __webpack_require__.e(8096).then(function() { return function() { return __webpack_require__(57388); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.9.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@qikserve/utils/http",

	},
	56558: {
		fallback: function() { return __webpack_require__.e(8096).then(function() { return function() { return __webpack_require__(82688); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.9.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@qikserve/utils/web-settings",

	},
	35202: {
		fallback: function() { return function() { return __webpack_require__(95093); }; },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "2.31.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "moment",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"2984": [
		11330,
		7566,
		53279,
		94291,
		60398,
		56558
	],
	"3155": [
		3155
	],
	"5898": [
		62508,
		59955,
		80103,
		77037,
		34477
	],
	"7760": [
		35202
	],
	"7938": [
		77938
	],
	"8826": [
		38826
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}